import { UnitValue } from "@vattenfall/core";

import { FinnishProductDetailsModel } from "../shared/services/finnish-product-details.model";

export namespace MySelectElectricityProduct {
  export class Fetch {
    static readonly type = "[MySelectElectricityProduct] Fetch";
    constructor(public productId: string, public campaignCode: string) {}
  }
  export class Loading {
    static readonly type = "[MySelectElectricityProduct] Loading";
    constructor(public productId: string) {}
  }
  export class Completed {
    static readonly type = "[MySelectElectricityProduct] Completed";
    constructor(public productId: string, public payload: FinnishProductDetailsModel) {}
  }
  export class Errorred {
    static readonly type = "[MySelectElectricityProduct] Errorred";
    constructor(public productId: string) {}
  }
  export class Selected {
    static readonly type = "[MySelectElectricityProduct] Selected";
    constructor(
      public redirectUrl: string,
      public productId: string,
      public campaignCode: string,
      public marketingCode: string,
      public estimatedKwhConsumption: number,
      public consumptionCode: string,
      public productType?: string,
      public agreementName?: string,
      public electricityPrice?: UnitValue
    ) {}
  }
}
